// Add this Set near the top of your App.js, outside the component
export const STOP_WORDS = new Set([
  'a', 'an', 'the', 'is', 'are', 'was', 'were', 'be', 'been', 'being',
  'have', 'has', 'had', 'do', 'does', 'did', 'will', 'would', 'should', 'can',
  'could', 'may', 'might', 'must', 'am', 'i', 'me', 'my', 'mine', 'myself',
  'you', 'your', 'yours', 'yourself', 'he', 'him', 'his', 'himself',
  'she', 'her', 'hers', 'herself', 'it', 'its', 'itself', 'we', 'us', 'our', 'ours', 'ourselves',
  'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 'who', 'whom',
  'this', 'that', 'these', 'those', 'and', 'but', 'or', 'nor', 'for', 'so', 'yet',
  'as', 'if', 'of', 'at', 'by', 'in', 'on', 'to', 'up', 'out', 'with', 'from',
  'into', 'onto', 'near', 'over', 'under', 'through', 'about', 'above', 'after',
  'again', 'against', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other',
  'some', 'such', 'no', 'not', 'only', 'own', 'same', 'than', 'too', 'very', 'just',
  'now', 'then', 'say', 'says', 'said', 'also', 'get', 'go', 'goes', 'got', 'gone',
  'how', 'why', 'when', 'where', 'while', 'aint', 'give', 'im', 'id', 'ive', 'ill',
  'its', 'isnt', 'arent', 'wasnt', 'werent', 'cant', 'wont', 'dont', 'doesnt', 'didnt',
  'hasnt', 'havent', 'hadnt'
]);